module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_447269870_L-small-cffdbdbc4067f2cec7bb450a25bd3242.jpg";